module.exports = __webpack_public_path__ + "img/saas_4.710b1a56.png";